import { Navigate } from '@pkvsinha/react-navigate';
import * as React from 'react';

function AppBar({ text }) {
    return (React.createElement("nav", { className: "fixed z-50 top-0 w-full flex bg-slate-50 justify-between shadow-lg h-12 lg:h-16 items-center" },
        React.createElement("div", { className: "w-1/3" },
            React.createElement(Navigate, { to: "/" },
                React.createElement("i", { className: "ml-8 md:ml-24 lg:ml-32 text-lg md:text-2xl fa-solid fa-left-long" }))),
        React.createElement("div", { className: "flex justify-center w-1/3" },
            React.createElement("span", null, text)),
        React.createElement("div", { className: "w-1/3" })));
}

export { AppBar };
//# sourceMappingURL=index.js.map
